import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactEditor, useSlate } from 'slate-react'
import { someNode } from '@udecode/slate-plugins'

import BaseElement from './BaseElement';

export function renderDocumentFooterElement(params) {

  return (props) => {
    if (props.element.type === 'document_footer') { 
      return (
          <DocumentFooterElement {...props} {...params} />
      );
    }
  
    return undefined;
  }

}



export const DocumentFooterPlugin = (params) => ({
  renderElement: renderDocumentFooterElement(params),
  voidType: ['break']
});

export default function DocumentFooterElement({ attributes, element, children, ...props }) {
  const { t } = useTranslation();
  const editor = useSlate();
  const path = ReactEditor.findPath(editor, element);
  const hasImage = someNode(editor, { at: path, match: (n) => n.type === 'image' })

  return (
    <BaseElement element={element}  type="document_footer" {...props}>
      {({ isEmpty }) => (
          <div {...attributes} contentEditable={hasImage ? false : undefined}>
              { isEmpty && <BaseElement.Placeholder text={t('editor.items.text')} /> }
              {children}
          </div>
      )}
    </BaseElement>
  )
}